<template>
  <div class="bg-black height-100 watch-info">
    <div class="main-polv" v-if="videoData">
      <div class="flex polv-tit">
        <!-- <a-row type="flex" class="title" justify="space-between" align="middle"> -->
        <div :span="12" class="flex align-center">
          <span class="schedule-name">{{ videoData.scheduleName }}</span>
          <!-- <span class="middle">{{ watchNum && watchNum.watchNum ? watchNum.watchNum : 0 }}人在线</span> -->
        </div>
        <div :span="6" class="flex align-center">
          <div @click="goAsk()" class="flex align-center cursor" style="margin-right: 20px">
            <img src="./img/ask-icon.png" class="icon-play" />提问
          </div>
          <div @click="goEvaluate()" class="flex align-center cursor" v-if="isShowEva" style="margin-right: 20px">
            <img src="./img/evaluate-icon.png" class="icon-play" />评价
          </div>
          <div
            @click="switchMainScreen()"
            class="flex align-center cursor"
            v-if="videoData.scene === 'ppt' && videoData.activityStatus === '2'"
          >
            <img src="./img/changeScreen.png" class="icon-play" />切换主副屏
          </div>
          <div class="header_title">
            <h1 class="icon_container">
              <div class="icon" v-if="userInfo.nickName">
                <img :src="userInfo.headImgUrl" alt="" class="stu-logo" />
              </div>
              <span>{{ userInfo.nickName }}</span>
            </h1>
          </div>
        </div>
      </div>
      <!-- </a-row> -->
      <a-row class="panel-body" type="flex" justify="space-between">
        <a-col :span="18" class="left-panel height-100">
          <div id="live" class="live height-100">
            <div id="player" class="height-100 width-100" v-show="videoData.activityStatus === '1'"></div>
            <div id="videoIdplayer" class="height-100 width-100" v-show="videoData.activityStatus !== '1'"></div>
          </div>
        </a-col>
        <a-col :span="6" class="hide-pagination height-100 flex-column">
          <div class="relative bg-dark-black plv-watch-pc height-100">
            <div v-if="videoData.scene === 'ppt'" class="height-40">
              <div id="ppt" class="height-100"></div>
            </div>
            <div
              id="wrap"
              :class="{
                'height-60': videoData.scene === 'ppt',
                'height-100': videoData.scene === 'polyv_channel'
              }"
            ></div>
            <div class="box">
              <div v-if="videoData.pushType === '2'" id="chat" class="width-100"></div>
              <resource
                :pushType="videoData.pushType"
                :classesName="videoData.classesName"
                v-if="videoData.activityStatus !== 0"
                :activityInfo="videoData"
                :planclassesId="studentData.planclassesId"
                @getResorce="getResorce"
                :resourceList="resourceList"
                @analysisPPt="analysisPPt"
              ></resource>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
    <ask-modal :visible.sync="askVisible" @refresh="refresh"></ask-modal>
    <evaluate-modal
      :visible.sync="evaluateVisible"
      @refresh="evaluatRefresh"
      :scheduleId="studentData.scheduleId"
    ></evaluate-modal>
    <answer-modal></answer-modal>
    <question-modal></question-modal>
    <CheckIn-modal></CheckIn-modal>
  </div>
</template>
<script>
// import { mapActions, mapMutations, mapState } from 'vuex'
import Vue from 'vue'
// import { loadJs } from '@/utils/domUtil.js'
import resource from './module/resource'
import askModal from './module/askModal'
import evaluateModal from '@/components/evaluateModal/evaluateModal'
import plvPlayer from './module/player/plvPlayer.vue'
import { mapState } from 'vuex'
import zModal from '@/components/ZModal'
import answerModal from './module/answerModal'
import questionModal from './module/questionModal'
import CheckInModal from './module/CheckInModal'
import { updateConfig } from '@polyv/interactions-receive-sdk'
export default {
  components: { resource, askModal, evaluateModal, plvPlayer, zModal, answerModal, questionModal, CheckInModal },
  data() {
    return {
      videoData: {},
      watchNum: null,
      studentData: {},
      watchTimer: null,
      scanBeginTime: 0,
      resourceList: [],
      doExerciseVisible: true,
      evaluateVisible: false,
      askVisible: false,
      chatRoom: null,
      playerJsSrc: 'https://player.polyv.net/jssdk/polyv-chatroom.min.js',
      player: null,
      videoIdplayer: null,
      itemUrls: [],
      userInfo: Vue.ls.get('USER_INFO'),
      plvPlayerDetail: {},
      answerCardSdk: null, // 答题卡SDK实例
      isShowAnswerCard: false, // 是否显示答题卡
      answerCardTitle: '', // 外部弹窗（容器）标题
      polvLastWatchTime: 0,
      polvStartWatchTime: 0,
      polvLastVideoTime: 0,
      isShowEva: true
    }
  },
  watch: {},
  async created() {
    this.initData()
     document.querySelector('body').setAttribute('style', 'overflow: auto')
  },
  async mounted() {
    this.mount()
  },
  destroyed() {
    console.log('disconnect............')
    if (this.watchTimer) {
      clearInterval(this.watchTimer)
    }
  },
  computed: {
    ...mapState({
      info: state => state.system.orgInfo
    })
    // userData() {
    //   return this.$store.getters.getUserData(['nickName', 'photo', 'telphone'])
    // },
    // ...mapState('course', ['examIdList', 'examId']),
  },
  // destroyed() {
  //   this.destroy()
  // },
  methods: {
    initData() {
      this.userInfo = Vue.ls.get('USER_INFO')
      if (this.$route.query) {
        this.studentData = this.$route.query
      }
      if (this.watchTimer) {
        clearInterval(this.watchTimer)
      }
      // if (!window.PolyvLiveSdk) {
      //   loadJs(this.playerJsSrc, this.loadPlayer)
      // }
      this.getStuVieoCheck()
      this.getResorce()
      console.log('scanBeginTime', parseInt(new Date().getTime()))
      this.scanBeginTime = parseInt(new Date().getTime())
    },
    async saveWatchTime() {
      const scanEndTime = parseInt(new Date().getTime())
      // console.log('time', scanEndTime - this.scanBeginTime)
      const params = {
        activityId: this.videoData.activityId,
        classesId: this.studentData.classesId,
        scheduleId: this.studentData.scheduleId,
        planclassesId: this.studentData.planclassesId ? this.studentData.planclassesId : '',
        state: this.videoData.activityStatus
      }
      if (this.videoData.activityStatus === '1') {
        params.startTimeStamp = this.scanBeginTime
        params.endTimeStamp = scanEndTime
        params.startTime = 0
        params.endTime = 0
        params.watchDuration = scanEndTime - this.scanBeginTime
        params.videoPlayedTime = scanEndTime - this.scanBeginTime
        this.scanBeginTime = scanEndTime
      } else {
        // console.log('time111', this.polvLastWatchTime, this.polvStartWatchTime, this.polvLastVideoTime)
        const time = this.polvLastWatchTime - this.polvStartWatchTime
        params.startTimeStamp = this.scanBeginTime
        params.endTimeStamp = scanEndTime
        params.startTime = parseInt(this.polvStartWatchTime * 1000)
        params.endTime = parseInt(this.polvLastWatchTime * 1000)
        params.videoPlayedTime = parseInt(time * 1000)
        params.watchDuration = parseInt(time * 1000) > 60000 ? 60000 : parseInt(time * 1000)
        this.polvStartWatchTime = this.polvLastWatchTime
        if (time === 0 || time < 0) {
          return
        }
        // console.log('time222', this.polvLastWatchTime, this.polvStartWatchTime, time)
      }
      // console.log('params', params)
      await this.$http.post(`/b/classes/live/v2/saveVideoProgressForPc`, params)
    },
    // 获取视频/直播详情数据
    async getStuVieoCheck() {
      const res = await this.$http.post(
        `/b/classes/wxapp/schedule/v2/check/${this.studentData.classesId}/${this.studentData.scheduleId}`
      )
      this.videoData = res
      this.isShowEva = !res.hasComment
      // console.log('this.videoData', this.videoData)
      const time = res
      if (time.startTime && time.endTime) {
        const start = time.startTime.split(' ')
        const end = time.endTime.split(' ')
        res.end = start[0] === end[0] ? end[1] : res.endTime
      }
      if (res.activityStatus === '2') {
        this.getStuVieoData()
      }
      this.watchTimer = setInterval(() => {
        // this.saveLastWatchTime()
        this.saveWatchTime()
      }, 60000)

      await this.initPolyv()
      this.initPolyIr()
      this.getWatchNum()
    },
    async getStuVieoData() {
      const params = {
        scheduleId: this.studentData.scheduleId,
        // scheduleId: 'b0578f1996a40dcd5a6c5dcca8f03128',
        classesId: this.studentData.classesId
      }
      const res = await this.$http.get(`/b/classes/wxapp/schedule/v2/playback/polyv/channel`, {
        params
      })
      this.videoData.videoId = res.videoId
      this.videoData.vodId = res.vodId
      this.loadPlayer()
    },
    initPolyv() {
      this.$nextTick(async () => {
        // const playsafe = await this.$http.get(`/b/material/web/matVideo/playToken/${this.plVid}`)
        const PolyvLiveSdk = window.PolyvLiveSdk
        const PolyvChatRoom = window.PolyvChatRoom
        // const vid = this.plVid
        const userInfo = Vue.ls.get('USER_INFO')
        this.ChatRoom = new PolyvChatRoom({
          roomId: this.videoData.channelId,
          userId: userInfo.id ? userInfo.id : '',
          accountId: userInfo.id ? userInfo.id : '',
          nick: userInfo.nickName ? userInfo.nickName : '',
          pic: userInfo.headImgUrl ? userInfo.headImgUrl : '',
          token: this.videoData.polyvChatRoomToken.token,
          enableAsk: false,
          showUserList: false,
          userType: this.videoData.scene === 'ppt' ? 'slice' : 'student',
          mediaChannelKey: this.videoData.polyvChatRoomToken.mediaChannelKey,
          version: '2.0',
          container: '#wrap',
          width: '100%',
          height: '100%',
          // enableAsk: false, // 是否开启提问
          enableWelcome: false, // 是否开启欢迎语
          enableOnlyTeacher: false, // 是否开启只看讲师功能
          roomMessage: function(data) {
            // TODO
            // data为聊天室socket消息，当有聊天室消息时会触发此方法
            console.log('sssssssssssssssssssss', data)
          },
          customChatColor: {
            selfBgColor: '#2b2c35',
            selfColor: '#fff',
            otherBgColor: '#2b2c35',
            otherColor: '#fff',
            specialBgColor: '#2b2c35',
            specialColor: '#fff'
          }
        })
        // console.log('chatroom1111', this.ChatRoom)
        // if (this.videoData.activityStatus === '1') {
        this.player = new PolyvLiveSdk({
          channelId: this.videoData.channelId,
          sign: this.videoData.sign, // 频道验证签名
          timestamp: this.videoData.timestamp, // 毫秒级时间戳
          appId: 'ewr9ekmmab', // polyv 后台的appId
          socket: this.ChatRoom.chat.socket,
          videoId: this.videoData.videoId,
          user: {
            userId: userInfo.id ? userInfo.id : '',
            userName: userInfo.nickName ? userInfo.nickName : '',
            pic: userInfo.headImgUrl ? userInfo.headImgUrl : ''
          }
        })
        var autoplay
        if (this.videoData.activityStatus === '1') {
          autoplay = true
        } else {
          autoplay = false
        }
        this.player.on(PolyvLiveSdk.EVENTS.CHANNEL_DATA_INIT, (event, data) => {
          this.player.setupPlayer({
            pptEl: '#ppt',
            el: '#player',
            type: 'auto',
            autoplay: autoplay, // 设置自动播放
            pptPlaceholder: true,
            switchPlayer: true,
            controllerPosition: 'player', // 控制条所在场景
            fixedController: true,
            pictureInPicture: true // 画中画
            // type: 'live',
            // pptNavBottom: '80px',
            // barrage: true, // 是否开启弹幕
            // defaultBarrageStatus: true,
          })
          // console.log('---频道信息---')
          // console.log('data', data)
          this.plvPlayerDetail = data

          // console.log('this.player', this.player)
          this.player.player.on('switchPlayer', this.switchMainScreen) // 点击控制栏切换按钮触发
          this.player.player.on('switchMainScreen', this.switchPlayer) // 点击控制栏切换按钮触发

          // this.player.player.on('loadedmetadata', function () {
          //   console.log('获得当前视频时长')
          //   console.log('duration', this.player.player.duration)
          // })
        })
        // }
        // const that = this
        // this.player.on(PolyvLiveSdk.EVENTS.STREAM_UPDATE, handleStreamUpdate) // 监听流状态变化
        // this.$nextTick(() => {
        //   this.switchPlayer()
        // })
        // this.initPolyIr()
      })
    },
    initPolyIr() {
      // const { updateConfig } = window.PolyvIRSDK
      // this.answerCardSdk = new AnswerCard()
      const userInfo = {
        nick: this.userInfo.nickName ? this.userInfo.nickName : '', // 昵称
        pic: this.userInfo.headImgUrl ? this.userInfo.headImgUrl : '', // 头像
        userId: this.userInfo.id ? this.userInfo.id : '' // 观众id
      }
      const channelInfo = {
        channelId: this.videoData.channelId, // 频道号
        roomId: this.plvPlayerDetail.roomId, // 房间号
        sessionId: this.plvPlayerDetail.sessionId // 频道场次id
      }
      updateConfig({
        userInfo: userInfo, // 观众信息
        channelInfo: channelInfo, // 频道信息
        socket: this.ChatRoom.chat.socket // 此处传入 socketio 实例，具体获取方式请看下文
        // viewerApiToken 更新函数
        // getViewerApiToken: async (callback) => {
        //   const viewerApiToken = await myViewerApiTokenGetter()
        //   callback({ viewerApiToken })
        // },
      })
    },
    async loadPlayer() {
      const playsafe = await this.$http.get(`/b/material/web/matVideo/playToken/${this.videoData.vodId}`)
      const polyvPlayer = window.polyvPlayer
      this.videoIdplayer = polyvPlayer({
        wrap: '#videoIdplayer',
        width: '100%',
        height: '100%',
        vid: this.videoData.vodId,
        ban_history_time: 'off',
        df: 3,
        autoplay: true,
        showHd: true, // 是否显示清晰度选择按钮
        pictureInPicture: true, // 画中画
        playsafe: playsafe
        // show_rate: 2
        // watchStartTime: this.lastWatchTime,
      })
      const that = this
      this.videoIdplayer.HTML5.on('videoTimeupdate', function(e) {
        // this.polvStartWatchTime = 0
        const currentTime =
          that.videoIdplayer && that.videoIdplayer.j2s_getCurrentTime ? that.videoIdplayer.j2s_getCurrentTime() : 0
        const videoTime =
          that.videoIdplayer && that.videoIdplayer.j2s_realPlayVideoTime
            ? that.videoIdplayer.j2s_realPlayVideoTime()
            : 0
        that.polvLastWatchTime = currentTime
        that.polvLastVideoTime = videoTime
        // console.log(
        //   'videoTimeupdate',
        //   that.polvLastWatchTime,
        //   that.polvLastVideoTime,
        //   that.polvLastWatchTime - that.polvStartWatchTime
        // )
      })
      this.videoIdplayer.on('s2j_onPlayOver', (...params) => {
        // console.log('当前视频播放完毕时触发', params)
        this.saveWatchTime()
      })
      this.videoIdplayer.on('s2j_onVideoSeek', (...params) => {
        // console.log('视频拖拽进度时触发', params)
        if (params[0] > params[1]) {
          this.polvStartWatchTime = params[1]
        }
      })
    },
    async getWatchNum() {
      const params = {
        activityId: this.videoData.activityId,
        type: 'watchNum'
      }
      const header = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
      await this.$http.post(`/b/classes/studentApi/addActivityInfoNum`, params, header)
      this.watchNum = await this.$http.post(`/b/classes/studentApi/getInfoNum`, params, header)
    },
    // 保存观看时长
    // async saveLastWatchTime() {
    //   this.scanEndTime = parseInt(new Date().getTime() / 1000)
    //   const params = {
    //     activityId: this.videoData.activityId,
    //     beginTime: this.scanBeginTime,
    //     endTime: this.scanEndTime,
    //     lastWatchTime: this.lastWatchTime,
    //     classesId: this.studentData.classesId,
    //     scheduleId: this.studentData.scheduleId,
    //     planclassesId: this.studentData.planclassesId ? this.studentData.planclassesId : '',
    //     stuId: this.studentData.stuId
    //   }
    //   this.scanBeginTime = this.scanEndTime - 0
    //   await this.$http.post(`/b/classes/web/stu/schedule/saveLastWatchTime`, params)
    // },
    async getResorce() {
      this.resourceList = await this.$http.get('/b/classes/web/stu/schedule/resource/v2/' + this.studentData.scheduleId)
    },
    async mount() {
      // const that = this
      window.onbeforeunload = function(e) {
        // that.saveLastWatchTime()
        e = window.event || e
        // 兼容IE8和Firefox 4之前的版本
        if (e) {
          e.returnValue = '确定离开本页面'
        }
        return '确定离开本页面'
      }
      this.doExerciseVisible = false
      this.getStuVieoCheck()
      this.getResorce() // 初始化资源列表
      // 设置聊天群id
      // this.setCurrentConversationID(this.studentData.scheduleId)
    },
    analysisPPt(urls) {
      this.itemUrls = urls
      if (!this.itemUrls || this.itemUrls.length < 1) {
        this.$message.info('当前讲义没有数据')
      }
    },
    // 参数传递的是你需要交换位置的两个div的ID
    handleSwitchPlayer() {
      // if (this.subType !== '1' && this.subType !== '0' && !forceChange) {
      //   this.$message.info('答题互动状态不允许切换位置')
      //   return
      // }
      console.log('切换切换切换')
      this.videoEnlarge = !this.videoEnlarge
      this.switchPlayer()
      this.$nextTick(function() {
        this.player && this.player.player.resize()
        this.player && this.player.player.resizeBarrage()
      })
    },
    switchPlayer() {
      // this.player.mainPosition = 'ppt'
      var insert = function(nodeInsert, nodeTo) {
        if (nodeInsert.insertAdjacentElement) {
          nodeTo.insertAdjacentElement('beforeBegin', nodeInsert)
        } else {
          nodeTo.parentNode.insertBefore(nodeInsert, nodeTo)
        }
      }
      var obj = document.createElement('a')
      var t1 = document.getElementById('live')
      var t2 = document.getElementById('ppt')
      insert(obj, t2)
      insert(t2, t1)
      insert(t1, obj)
    },
    switchMainScreen() {
      console.log('切换切换切换')
      this.handleSwitchPlayer()
    },
    goAsk() {
      this.askVisible = true
    },
    refresh() {
      // console.log(this.$refs.postRef)
      this.askVisible = false
    },
    goEvaluate() {
      this.evaluateVisible = true
    },
    evaluatRefresh() {
      // console.log(this.$refs.postRef)
      this.evaluateVisible = false
      this.isShowEva = false
    },
    // 切换速率
    changeRate(value) {
      this.videoIdplayer && this.videoIdplayer.changeRate(value)
    }
  }
}
</script>
<style lang="less">
@import './index.less';
</style>
<style lang="less">
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #666;
}
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  border: 1px solid #666;
  background-color: #222;
}
::-webkit-scrollbar-track {
  border: 1px solid #666;
  border-radius: 3px;
  background-color: #666;
}
.watch-info {
  width: 100%;
  position: absolute;
}
</style>
